import { Link, useLocation } from 'react-router-dom';
import { Card, CardBody } from '../components/ui/card.js';

/**
 * Phase 5b — proper 404 page. Replaces the previous silent
 * `Navigate to="/"` on unmatched routes, which masked broken links and
 * confused users who pasted an outdated URL into the address bar.
 */
export function NotFoundPage(): JSX.Element {
  const location = useLocation();
  return (
    <Card>
      <CardBody>
        <div className="flex flex-col items-center text-center py-12 gap-3">
          <p className="text-6xl font-semibold tabular-nums text-ink-muted">404</p>
          <h1 className="text-xl font-semibold">Page not found</h1>
          <p className="text-sm text-ink-muted max-w-md">
            We couldn't find anything at{' '}
            <code className="px-1.5 py-0.5 bg-surface-alt rounded text-xs font-mono">
              {location.pathname}
            </code>
            . The link may be outdated or the page may have moved.
          </p>
          <Link
            to="/"
            className="mt-2 inline-flex items-center px-4 py-2 rounded-md bg-accent text-white text-sm hover:opacity-90"
          >
            Back to dashboard
          </Link>
        </div>
      </CardBody>
    </Card>
  );
}
